module.exports = __webpack_public_path__ + "img/roll.b498b837.svg";